import React from "react";
import { Row, Col } from "react-bootstrap";
import { bgvStatusValues } from "../../../bgv-api/dbMapping";

const ChangeStatus = ({
    name,
    label = "Change Status",
    options = [],
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    onStatusChange = () => { },
}) => {
    const isOpsSupervisor = sessionStorage.getItem("user_category") === "Operation Supervisor";

    return (
        <Row className="my-3">
            <Col sm={3}>
                <label htmlFor={name}>{label}</label>
            </Col>
            <Col sm={9}>
                <select
                    className={`form-control ${touched[name] && errors[name] ? "is-invalid" : ""}`}
                    name={name}
                    id={name}
                    value={values[name]}
                    onBlur={handleBlur}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (value === bgvStatusValues.InsuffCleared) {
                            e.preventDefault();
                            return;
                        }

                        handleChange(e);         // Formik value update
                        onStatusChange(e);       // Custom handler (e.g., API call, save to DB, etc.)
                    }}
                >
                    {options.map((option, i) => (
                        <option key={i} value={option.value ?? option}>
                            {option.label ?? option}
                        </option>
                    ))}
                </select>
                {touched[name] && errors[name] && (
                    <small className="text-danger form-text">{errors[name]}</small>
                )}
            </Col>
        </Row>
    );
};

export default ChangeStatus;
